import ItemVariation from 'src/models/item/ItemVariation'
import Model, { encoders, ID } from 'src/models/model'
import { ORDER_ITEM_TYPES } from 'src/models/order-item/OrderItem'
import ItemPackage from 'src/models/package/ItemPackage'
import TicketType from 'src/models/showing/TicketType'
export default class ItemPackageItem extends Model {
  static name = 'ItemPackageItem'

  static deletable = true
  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true,
        required: true
      },

      ticketType: {
        type: TicketType,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },

      itemVariation: {
        type: ItemVariation,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },

      itemPackage: {
        type: ItemPackage,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },

      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      }
    }

    this.computed = {
      requiresPreparation () {
        return this.itemVariation?.requiresPreparation || false
      },
      areSalesRequirementsUnmet () {
        return this.itemVariation?.areSalesRequirementsUnmet || false
      }
    }
  }

  get itemType () {
    if (!_.isNil(this.ticketType)) {
      return ORDER_ITEM_TYPES.TICKET
    }

    if (!_.isNil(this.itemVariation)) {
      return ORDER_ITEM_TYPES.ITEM
    }

    return null
  }
}
